import moment from 'moment';
import { formatNumber } from '../helpers/utils';

export const calculateNewBalances = (balances, beginDate, endDate, ptoAnnualAmount) => {
  const newBalances = JSON.parse(JSON.stringify(balances));
  // earned adjustment for current date
  const endOfYear = moment(beginDate).endOf('year');
  const endDateThisYear = moment.min(moment(endDate), endOfYear);
  const daysPassed = Math.ceil((endDateThisYear).diff(moment(beginDate), 'days', true));
  const earned = formatNumber((ptoAnnualAmount / 365) * daysPassed);
  newBalances.pto.earned = formatNumber(
    newBalances.pto.earned + earned
  );
  newBalances.pto.balance = formatNumber(
    newBalances.pto.balance + earned
  );

  return newBalances;
}



// WEBPACK FOOTER //
// ./src/helpers/balanceTableCalculator.js